import {
  call, put, takeLatest, all, select
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions } from 'react/api/actions/ticketDetails';

function throwErrorToLog(message) {
  return console.error(message); // eslint-disable-line
}

function* fetchData(id) {
  const criteria = [
    'id',
    'key',
    'title',
    'description',
    'created',
    'dueDate',
    'modified',
    'whenStatusChanged',
    'ticketStatus',
    'ticketType.id',
    'ticketType.description',
    'ticketResolution.id',
    'ticketResolution.description',
    'userCreated.id',
    'userCreated.name',
    'userModified.id',
    'userModified.name',
    'userAssigned.id',
    'userAssigned.name',
    'lastUserChangedStatus.id',
    'lastUserChangedStatus.name',
    'ticketLinked.*',
    'ticketLinked.route.*',
    'ticketLinked.location.*',
    'ticketLinked.user.*',
    'ticketLinked.tasks.*',
    'ticketLinked.tasks.taskLinkeds.*',
    'ticketLinked.tasks.type.*',
    'ticketLinked.tasks.taskStatus.description',
    'comments.*',
    'comments.userCreated.*'
  ];

  const data = { criteriaChain: [{ and: [{ attr: 'id', eq: id }] }], firstResult: 0, maxResults: 1 };

  const url = `/Ticket/restrictions?criteria={"filters":${JSON.stringify(criteria)}}`;
  const encodedUrl = encodeURI(url);
  return yield call(defaultFetch, encodedUrl, data, 'POST');
}

function handleFetchChats(ticketId, configuration) {
  const companyId = configuration?.globalConfiguration?.authConfigId;

  const myHeaders = new Headers({
    'Content-Type': 'application/x-www-form-urlencoded'
  });

  const config = {
    headers: myHeaders
  };

  const url = `https://chat-qa.greenmile.com/Api/TicketMessage/${companyId}/${ticketId}`;

  return fetch(url, config);
}

function* fetchChats({ id: ticketId, key: screenKey }) {
  yield put({ type: actions.setLoadingChats, payload: true });
  const { configuration } = yield select();

  const response = yield call(handleFetchChats, ticketId, configuration);
  const chats = yield response.json();

  if (!response.error) {
    yield put({
      type: actions.setChatsToState,
      payload: { screenKey, chats }
    });
  } else {
    throwErrorToLog('Error trying to fecth chats!!');
  }

  yield put({ type: actions.setLoadingChats, payload: false });
}

function* fetchTicketDetails({ payload }) {
  yield put({ type: actions.setLoading, payload: true });
  yield put({ type: actions.setLoadingChats, payload: true });
  const response = yield call(fetchData, payload.id);
  const { error } = response;

  if (!error && response.length) {
    yield put({
      type: actions.setTicketDetails,
      payload: {
        screenKey: payload.key,
        data: response[0]
      }
    });
  } else {
    throwErrorToLog('Error trying to fetch the Ticket data');
  }

  yield put({ type: actions.setLoading, payload: false });
  yield call(fetchChats, payload);
}

function* persistComment({ payload }) {
  yield put({ type: actions.setProcessingComment, payload: true });

  const {
    ticketId, textarea: note, screenKey, commentToEdit: commentEdited
  } = payload;

  const isEdit = !!commentEdited?.get;
  const commentId = isEdit && commentEdited.get('id');
  const when = Date.now();
  const data = { ticket: { id: ticketId }, note, when };
  let url = '/TicketComment';
  let method = 'POST';
  let actionType = actions.setCommentToState;

  if (isEdit) {
    url = `/TicketComment/${commentId}`;
    method = 'PUT';
    actionType = actions.updateACommentOnState;
    data.id = commentId;
  }

  const response = yield call(defaultFetch, url, data, method);

  if (!response.error) {
    const { user } = yield select();
    const userId = user.get('id');
    const userName = user.get('name');
    const commentToState = {
      id: isEdit ? commentId : response.id,
      userCreated: {
        id: userId,
        name: userName
      },
      when,
      note
    };

    yield put({
      type: actionType,
      payload: { commentToState, screenKey }
    });
  } else {
    throwErrorToLog('Error trying to persist Comments!!');
  }

  yield put({ type: actions.setProcessingComment, payload: false });
}

function* deleteComment({ payload }) {
  yield put({ type: actions.setProcessingComment, payload: true });

  const { screenKey, commentToDelete } = payload;

  const commentId = commentToDelete.get('id');
  const url = `/TicketComment/${commentId}`;

  const response = yield call(defaultFetch, url, null, 'DELETE');

  if (!response.error) {
    yield put({
      type: actions.deleteCommentOnState,
      payload: { commentId, screenKey }
    });
  } else {
    throwErrorToLog('Error trying to delete a Comment!!');
  }

  yield put({ type: actions.setProcessingComment, payload: false });
}

function* watchTicketDetailsMounted() {
  yield takeLatest(actions.getTicketDetails, fetchTicketDetails);
}

function* watchAddNewComment() {
  yield takeLatest(actions.handlePersistComment, persistComment);
}

function* watchDeleteSomeComment() {
  yield takeLatest(actions.handleDeleteComment, deleteComment);
}

export default function* () {
  yield all([
    watchTicketDetailsMounted(),
    watchAddNewComment(),
    watchDeleteSomeComment()
  ]);
}
